export const privacyConstants = {
  LOAD_REQUEST: 'PRIVACY_LOAD_REQUEST',
  LOAD_SUCCESS: 'PRIVACY_LOAD_SUCCESS',
  LOAD_FAILURE: 'PRIVACY_LOAD_FAILURE',
}
